import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useTranslation } from 'react-i18next';

interface FloatingFilterButtonProps {
  activeFiltersCount: number;
  onClick: () => void;
}

const FloatingFilterButton: React.FC<FloatingFilterButtonProps> = ({
  activeFiltersCount,
  onClick
}) => {
  const { t } = useTranslation('practitioners');

  return (
    <div className="fixed bottom-6 right-6 z-40 lg:hidden">
      <Button
        onClick={onClick}
        className="relative bg-amber-600 hover:bg-amber-700 text-white rounded-full h-14 w-14 shadow-lg hover:shadow-xl transition-all duration-200 ring-4 ring-white"
        size="icon"
        aria-label={t('filters')}
      >
        <SlidersHorizontal className="h-6 w-6" />
        {activeFiltersCount > 0 && (
          <Badge 
            className="absolute -top-2 -right-2 bg-red-500 text-white min-w-[20px] h-5 text-xs font-bold"
            variant="destructive"
          >
            {activeFiltersCount}
          </Badge>
        )}
      </Button>
    </div>
  );
};

export default FloatingFilterButton;